module.exports = __webpack_public_path__ + "static/media/message.31e771c2.svg";